import {css} from 'emotion'
import { Easings } from '../core'

export const PanStyle = (x, enable) => css({
  overflow: 'auto',
  maxWidth: 'scroll',
}, !!enable && {
  'ul.flex': {
    justifyContent: 'flex-start',
    '& > li': {
      flex: '1 0 auto',
    }
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/pan.js